import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-save-payment-details',
  templateUrl: './save-payment-details.component.html',
  styleUrls: ['./save-payment-details.component.css']
})
export class SavePaymentDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
